import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import {
  ViewState,
  ValidateState,
  CrudlStatus
} from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";

import { LoadScreen } from "../../Common/LoadScreen";
import { SBLSelector } from "../../Sites/SBLSelector";
import { OrderItemTable } from "./OrderItemTable";
import { BPMAddressSelector } from "../../Common/BPMAddressSelector";

export class OrderCard extends React.Component {
  updateObject = (field, value) => {
    this.props.updateValue(field, value);
  };

  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
          className="custom"
        >
          <div className="ui-g">
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">{this.getCustomerInformation()}</div>
                <div className="ui-g-5">{this.getOrderInformation()}</div>
                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  {/* {this.getAdditionalView()} */}
                  {this.getProductDisplay()}
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={() => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
  getCustomerInformation = () => {
    return (
      <React.Fragment>
        {this.props.crudlState !== CrudlStatus.CREATE && (
          <div className="ui-g-12">
            <div className="ui-g-3">
              <label className="input-label">Order No</label>
            </div>
            <div className="ui-g-9">
              <label className="input-label">
                {format.formatId(this.props.editedObject.id)}
              </label>
            </div>
          </div>
        )}
        <div className="ui-g-12">
          <div className="ui-g-3">
            <label className="input-label">Select Customer</label>
          </div>

          <div className="ui-g-9">
            <pr.Dropdown
              value={this.props.editedObject.clientId || ""}
              options={this.props.customerOptions}
              onChange={e => {
                this.props.updateValue("clientId", e.value);
              }}
              filter={true}
              filterBy="label"
              filterPlaceholder="Search"
              disabled={this.props.crudlState === CrudlStatus.VIEW}
              style={{ width: "100%" }}
            />
          </div>
        </div>
        <div className="ui-g-12">
          <div className="ui-g-3">
            <label className="input-label">Default Customer Address</label>
          </div>

          <div className="ui-g-9">
            <textarea
              id={this.props.editedObject.customerDetails + " Details"}
              disabled={true}
              rows={5}
              placeholder=""
              value={format.readInCustomerAddressDetails(
                this.props.editedObject.clientId,
                this.props.customerList
              )}
              style={{ width: "100%", backgroundColor: "transparent" }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  getOrderInformation = () => {
    return (
      <div className="ui-g-12">
        <React.Fragment>
          <div className="ui-g-3">
            <label className="input-label">Description</label>
          </div>

          <div className="ui-g-9">
            <pr.InputText
              value={this.props.editedObject.shortDescription}
              onChange={e =>
                this.props.updateValue("shortDescription", e.target.value)
              }
              disabled={this.props.crudlState === CrudlStatus.VIEW}
            />
          </div>
        </React.Fragment>
        <React.Fragment>
          <div className="ui-g-3">
            <label className="input-label"> Customer Reference No</label>
          </div>

          <div className="ui-g-9">
            <pr.InputText
              value={this.props.editedObject.clientReferenceNumber}
              onChange={e =>
                this.props.updateValue("clientReferenceNumber", e.target.value)
              }
              disabled={this.props.crudlState === CrudlStatus.VIEW}
            />
          </div>
        </React.Fragment>

        <React.Fragment>
          <div className="ui-g-3">
            <label className="input-label">Delivery Date(Expected)</label>
          </div>
          <div className="ui-g-9">
            <pr.Calendar
              showIcon={false}
              disabled={this.props.crudlState === CrudlStatus.VIEW}
              id="date_calendar"
              value={this.props.editedObject.deliveryDate || ""}
              style={{ width: "100%" }}
              inputStyle={{ width: "100%" }}
              onChange={e => this.props.updateValue("deliveryDate", e.value)}
            />
          </div>
        </React.Fragment>

        <React.Fragment>
          <div className="ui-g-3">
            <label className="input-label">Ship Together</label>
          </div>

          <div className="ui-g-9">
            <pr.Dropdown
              value={this.props.editedObject.shipTogether}
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false }
              ]}
              onChange={e => {
                this.props.updateValue("shipTogether", e.value);
              }}
              disabled={this.props.crudlState === CrudlStatus.VIEW}
              style={{ width: "100%" }}
            />
          </div>

          {this.props.editedObject.shipTogether === true && (
            <React.Fragment>
              <div className="ui-g-3">
                <label className="input-label">
                  Does Delivery Address differ than Default Address?
                </label>
              </div>

              <div className="ui-g-9">
                <pr.Dropdown
                  value={this.props.editedObject.specificAddressRequired}
                  options={[
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" }
                  ]}
                  onChange={e => {
                    this.props.updateValue("specificAddressRequired", e.value);
                  }}
                  disabled={this.props.crudlState === CrudlStatus.VIEW}
                  style={{ width: "100%" }}
                />
              </div>

              {this.props.editedObject.specificAddressRequired === "true" && (
                <div className="ui-g-12">
                  <SBLSelector
                    type={"CLIENT"}
                    updateState={this.props.updateValue}
                    businessId={this.props.editedObject.clientId}
                    siteId={this.props.editedObject.siteId}
                    buildingId={this.props.editedObject.buildingId}
                    locationId={this.props.editedObject.locationId}
                    disabled={this.props.crudlState === CrudlStatus.VIEW}
                    showAddress={true}
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  };

  getProductDisplay = () => {
    return (
      <React.Fragment>
        <h3>Order Items</h3>

        <OrderItemTable
          productList={this.props.productList}
          productTableColumns={this.props.productTableColumns}
          productExpandedRows={this.props.productExpandedRows}
          updateState={this.props.updateState}
          editedObject={this.props.editedObject}
          updateValue={this.props.updateValue}
          productAddModal={this.props.productAddModal}
          hideProductEditor={this.props.hideProductEditor}
          removeProductFromSelectedProducts={
            this.props.removeProductFromSelectedProducts
          }
          updateProductSelected={this.props.updateProductSelected}
          disabled={this.props.crudlState === CrudlStatus.VIEW}
        />
      </React.Fragment>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Orders/UI/OrderCard.js